import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import WizardDataboardIntroPopupComponent from 'webapp/components/wizard/tour/popup-wizard-databoard-intro';

import TourBase from 'webapp/models-custom/tour';

export default class WizardDataboardIntroTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.WIZARD_DATABOARD_INTRO;

	override popupComponent = WizardDataboardIntroPopupComponent;

	get id(): string {
		return TourId.WIZARD_DATABOARD_INTRO;
	}

	override get keyForPersistantDone(): string {
		return WizardDataboardIntroTour.keyForPersistantDone;
	}

	override start(): void {
		super.start();
		this.popupService
			.createModal(WizardDataboardIntroPopupComponent, {
				popupClass: 'popup-type-wizard-databoard-intro',
			})
			.open();
		this.markDone(); // once seen, it's done
	}

	// no stepData - all is in modal.wizard-databoard-intro already
}
